export default __webpack_public_path__ + "static/media/158.43ad11d9.png";